"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var defaultProps = {
    onChange: function () {
        /* do nothing */
    },
};
exports.default = defaultProps;
//# sourceMappingURL=defaultProps.js.map